<template>
  <div class="min-h-screen relative overflow-hidden">
    <!-- Background Image with White Transparent Overlay -->
    <div 
      class="absolute inset-0 bg-cover bg-center bg-no-repeat"
      :style="{ backgroundImage: `url(${backgroundImage})` }"
    ></div>
    <div class="absolute inset-0 bg-white bg-opacity-90"></div>

    <!-- Content -->
    <div class="relative z-10 min-h-screen flex items-center justify-center p-4 sm:p-6 lg:p-8">
      <div class="w-full max-w-7xl">

        <!-- Brand Logos -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-2 mx-auto">
          <div
            v-for="(brand) in brands"
            :key="brand.id"
            class="brand-card"
            :class="{ 'animate-brand': isAnimating }"
          >
            <div class="brand-logo-container">
              <img
                :src="brand.logo"
                :alt="brand.name"
                class="brand-logo"
                @click="selectBrand(brand)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { BRANDS } from '@/config/brands'
import type { Brand } from '@/config/brands'

const router = useRouter()
const brands = ref(BRANDS)
const isAnimating = ref(false)

// eslint-disable-next-line @typescript-eslint/no-var-requires
const backgroundImage = require('@/assets/staticbg.png')

onMounted(() => {
  // Trigger animation on mount
  setTimeout(() => {
    isAnimating.value = true
  }, 100)
})

const selectBrand = (brand: Brand) => {
  router.push({
    name: 'signup',
    params: { brandSlug: brand.slug }
  })
}
</script>

<style scoped>
.brand-card {
  transition: all 0.3s ease;
  opacity: 0;
  transform: scale(0.5);

}

.brand-card.animate-brand {
  animation: fadeInScale 1.9s ease forwards;
}

.brand-logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-logo-container img {
  cursor: pointer;
}

.brand-logo {
  width: 90%;
  object-fit: contain;
}

@media (max-width: 640px) {
  .brand-logo {
    width: 100%;
  }
  
  .brand-logo-container {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

@keyframes fadeInScale {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>